import HttpRequest from './http_request';

export default class ScheduleSpecialPeriodProvider extends HttpRequest {
  async list(scope, page) {
    const { data } = await this.get('/', { function: 'get-schedule-special-periods', ...scope, page });
    return data;
  }
  async users(scope) {
    const { data } = await this.get('/', { function: 'get-schedule-special-period-users', ...scope });
    return data;
  }
  async detail(id) {
    const { data } = await this.get('/', { function: 'get-schedule-special-period', id });
    return data;
  }
  async save(payload) {
    const { data } = await this.create('/', { function: 'save-schedule-special-period', ...payload });
    return data;
  }
  async cancel(id, revision) {
    const { data } = await this.create('/', { function: 'cancel-schedule-special-period', id, revision });
    return data;
  }
}
